module.exports = __webpack_public_path__ + "img/瓦屋镇.599f7d76.png";